// Общий entry point для всех путей add-attachment (DnD / paste / file-picker).
// Прогоняет файлы через `validateAndSliceFiles`, показывает соответствующий
// toast и (если что-то прошло валидацию) запускает upload. Возвращает
// `accepted.length` для caller'а, если он хочет.

import toast from "react-hot-toast";
import type { TFunction } from "i18next";

import { validateAndSliceFiles, type ValidateAttachInput } from "./validateAndSliceFiles";

const TOAST_DURATION = 5_000;

export interface RunValidationAndUploadInput extends ValidateAttachInput {
    upload: (files: File[]) => Promise<unknown>;
    t: TFunction<"chat">;
}

export async function runValidationAndUpload({
    files,
    limits,
    currentCounts,
    policy,
    upload,
    t,
}: RunValidationAndUploadInput): Promise<number> {
    const result = validateAndSliceFiles({ files, limits, currentCounts, policy });

    switch (result.rejectReason) {
        case "modeNoFiles":
            toast.error(t("prompt.dropZone.modeNoFiles"), { duration: TOAST_DURATION });
            return 0;
        case "unsupportedKind":
            toast.error(t("prompt.dropZone.unsupportedKind"), { duration: TOAST_DURATION });
            return 0;
        case "tooLarge":
            toast.error(t("prompt.dropZone.tooLarge", { maxMb: result.rejectMaxSizeMb ?? 0 }), {
                duration: TOAST_DURATION,
            });
            return 0;
        case "maxReached":
            toast.error(t("prompt.dropZone.maxReached"), { duration: TOAST_DURATION });
            return 0;
        default:
            break;
    }

    if (result.droppedTotal > 0) {
        toast(
            t("prompt.dropZone.partialAdded", {
                added: result.accepted.length,
                total: files.length,
            }),
            { duration: TOAST_DURATION },
        );
    }

    try {
        await upload(result.accepted);
    } catch {
        // ошибки видны через items[*].status === "error"
    }
    return result.accepted.length;
}
